"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
function addMetaToState(state, formResponse) {
    if (!isEmpty_1.default(formResponse)) {
        state.meta = JSON.stringify(Object.assign({}, JSON.parse(state.meta || '{}'), { formResponses: [formResponse] }));
    }
}
exports.addMetaToState = addMetaToState;
//# sourceMappingURL=addMetaToState.js.map